// extracted by mini-css-extract-plugin
export default {"ebanner":"mg-z"};